import { Button } from '@mui/material'
import PasswordField from '../common/PasswordField'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

const EnterNewPassword = ({ email, token, setAlert }) => {
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [isPasswordConfirmed, setIsPasswordConfirmed] = useState(false)

  const reset = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/auth/password/reset`,
        {
          method: 'POST',
          body: JSON.stringify({
            email,
            token,
            password,
            repeatPassword,
          }),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      const data = await response.json()
      if (data.success) {
        navigate('/login')
      } else {
        setAlert({
          text: data.message ?? 'Could not reset password. Try again later.',
          color: 'error',
        })
      }
    } catch (error) {
      setAlert({
        text: 'Could not reset password. Try again later.',
        color: 'error',
      })
      console.error('Could not reset password', error)
    }
  }

  return (
    <>
      <PasswordField
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        fullWidth
        confirmation={{
          label: 'Repeat password',
          mismatchMessage: 'Passwords must match!',
          onMatchChange: setIsPasswordConfirmed,
          onValueChange: setRepeatPassword,
        }}
      />
      <Button
        id="verify-button"
        variant="contained"
        color="primary"
        disabled={!password || !isPasswordConfirmed}
        onClick={() => reset()}
      >
        Confirm
      </Button>
    </>
  )
}

export default EnterNewPassword
